module.exports = __webpack_public_path__ + "static/media/ppe_hi_vis.5eea7327.png";